import React from "react";
import { useSiteStructureQueryQuery } from "../../generated/graphql";
import { GraphQlSelect } from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const SiteOwnerSelect = (props) => {
    const query = useSiteStructureQueryQuery();
    const filteredSiteStructures = query.data?.siteStructures?.filter((site) =>
        site?.siteStructureGroup?.name === "DIGITAL"
    );
    return props.valueIsId ? (
        <GraphQlSelectId queryResult={{ ...query, data: { siteStructures: filteredSiteStructures } }} {...props} labelField="name" />
    ) : (
        <GraphQlSelect queryResult={{ ...query, data: { siteStructures: filteredSiteStructures } }} {...props} labelField="name" />
    );
}
